import React from 'react';
import { Gift, Trophy } from 'lucide-react';
import { RankingAward } from 'types/ranking';
import './styles.scss';

interface AwardDisplayProps {
  award: RankingAward;
  variant?: 'banner' | 'card' | 'compact';
  className?: string;
}

const AwardDisplay: React.FC<AwardDisplayProps> = ({
  award,
  variant = 'card',
  className = '',
}) => {
  if (variant === 'banner') {
    return (
      <div className={`award-display award-banner ${className}`}>
        <div className="award-banner-content">
          <div className="award-banner-icon">
            <Trophy size={32} />
          </div>
          <div className="award-banner-info">
            <div className="award-banner-label">Prêmio deste Ranking</div>
            <h3 className="award-banner-title">{award.name}</h3>
            {award.description && (
              <p className="award-banner-description">{award.description}</p>
            )}
          </div>
          {award.image && (
            <div className="award-banner-image">
              <img src={award.image} alt={award.name} />
            </div>
          )}
        </div>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className={`award-display award-compact ${className}`}>
        <div className="award-compact-icon">
          {award.image ? (
            <img src={award.image} alt={award.name} />
          ) : (
            <Gift size={20} />
          )}
        </div>
        <div className="award-compact-info">
          <span className="award-compact-label">Prêmio:</span>
          <span className="award-compact-name">{award.name}</span>
        </div>
      </div>
    );
  }

  // variant === 'card'
  return (
    <div className={`award-display award-card ${className}`}>
      <div className="award-card-header">
        <div className="award-card-icon">
          <Trophy size={24} />
        </div>
        <h4 className="award-card-title">Prêmio</h4>
      </div>
      {award.image && (
        <div className="award-card-image">
          <img src={award.image} alt={award.name} />
        </div>
      )}
      <div className="award-card-body">
        <h3 className="award-card-name">{award.name}</h3>
        {award.description && (
          <p className="award-card-description">{award.description}</p>
        )}
      </div>
    </div>
  );
};

export default AwardDisplay;
